<template>
	<div style="display:flex;flex-direction: column;height:100vh;">
		<Chead />
		<div
			id="primaryContent"
			class="other_content"
			style="height:0;flex:1;overflow:auto;"
		>
			<router-view />
		</div>
	</div>
</template>

<script setup lang="ts">
import Chead from '@/components/Chead.vue';
</script>

<style lang='scss' scoped></style>